<template>
	<div>
		<v-app-bar flat app class="" style="z-index: 99;">
			<v-btn id="btn-drawerNav" text small @click.stop="clickDrawer">
				<img width="20" src="/assets/icon/toggle-list.svg" style="opacity: 0.55;" v-if="isDrawer === 60">
				<img width="20" src="/assets/icon/toggle-icon.svg" style="opacity: 0.55;" v-else>
			</v-btn>
			<v-spacer></v-spacer>

			<v-menu open-on-hover offset-y offset-x max-width="200" transition="slide-y-transition" content-class="rounded-lg" v-if="userData">
				<template v-slot:activator="{ on, attrs }">
					<v-btn large text class="menu-btn pl-1 pr-0 rounded-lg" v-bind="attrs" v-on="on">
						<div class="d-none d-md-block cl-grey text-right btn-user-name">
							<div class="text-capitalize">{{ userData.member_name }}</div>
							<div class="font-weight-bold primary--text">{{ userData.member_network_code }}</div>
						</div>
						<div class="d-block d-md-none cl-grey text-right btn-user-name">
							<div class="text-capitalize">{{ userData.member_name | ellipsisText(10) }}</div>
							<div class="font-weight-bold primary--text">{{ userData.member_network_code }}</div>
						</div>
						<div class="px-2">
							<v-img width="40" height="40" class="user-img rounded-pill" :src="(userData.member_image_url) ? userData.member_image_url : require('/public/assets/image/profile-pict.png')"></v-img>
						</div>
						<v-icon color="grey darken-1">mdi-chevron-down</v-icon>
					</v-btn>
				</template>
				<v-list>
					<router-link class="text-deco" :to="{ name: 'profil'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-account</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">Profile</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<router-link class="text-deco" :to="{ name: 'change-password'}">
						<v-list-item link>
							<v-icon small class="pr-3">mdi-key-variant</v-icon>
							<v-list-item-content>
								<v-list-item-title>
									<span class="font-size-10">Change Password</span>
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</router-link>
					<v-list-item link @click.native="onLogout">
						<v-icon small class="pr-3 red--text darken-3">mdi-exit-to-app</v-icon>
						<v-list-item-content>
							<v-list-item-title>
								<span class="font-size-10 font-weight-bold red--text darken-3">Logout</span>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-app-bar>
	</div>
</template>

<script>
// import { createNamespacedHelpers } from 'vuex';
// const { mapActions, mapState } = createNamespacedHelpers('autentikasi');
import { mapState, mapActions } from 'vuex'

export default {
	data() {
		return {
		}
	},
	props: ['isDrawer'],
	computed: {
		...mapState('autentikasi', ['userData']),
	},
	watch: {
	},
	methods: {
		...mapActions('autentikasi', ['logout']),

		clickDrawer() {
			this.$emit('childToParent')
		},
		onLogout() {
			this.logout().then( () => {
				this.$router.push({ name: 'login' })
			})
		},
	},
	mounted() {
	}
};
</script>
